var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"w-max rounded-md",attrs:{"alt":_vm.$t('popupCard.addCard.photoExample'),"src":require("../../../assets/card.jpg")}})}
var staticRenderFns = []

export { render, staticRenderFns }